import { useEffect } from "react";

const SCRIPT_ID = "vercel-speed-insights";
const SCRIPT_SRC = "/_vercel/speed-insights/script.js";

declare global {
  interface Window {
    si?: (...args: unknown[]) => void;
    siq?: unknown[];
  }
}

const setupSpeedInsightsQueue = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (!window.si) {
    window.si = (...args: unknown[]) => {
      (window.siq = window.siq || []).push(args);
    };
  }
};

const ensureScript = () => {
  if (typeof document === "undefined" || !import.meta.env.PROD) {
    return;
  }

  const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
  if (existingScript) {
    return existingScript;
  }

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.defer = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);

  return script;
};

const VercelSpeedInsights = () => {
  useEffect(() => {
    setupSpeedInsightsQueue();
    ensureScript();
  }, []);

  return null;
};

export default VercelSpeedInsights;